/**
 * @file Web gallery scroller loader enhanced with responsibility to display the web gallery upsell.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { WEB_GALLERY_UPSELL_MODAL } from '../../../constants/modals';
import PhotoGridScrollLoader from '../../../components/grid/components/PhotoGridScrollLoader';

class WebGalleryScrollLoaderWithUpsell extends Component {
  static propTypes = {
    loadMore: PropTypes.func.isRequired,
    shouldLoadMore: PropTypes.bool.isRequired,
    scrollPercentage: PropTypes.number,
    children: PropTypes.oneOfType([PropTypes.node, null]),
    loadOnWheel: PropTypes.bool,
    openModal: PropTypes.func.isRequired,
    hasSeenUpsell: PropTypes.bool.isRequired,
    markUpsellSeen: PropTypes.func.isRequired,
    disableUpsell: PropTypes.bool,
    timesToLoadBeforeUpsell: PropTypes.number,
    indicesRendered: PropTypes.array,
    recordsLength: PropTypes.number,
  };

  static defaultProps = {
    timesToLoadBeforeUpsell: 2,
  };

  determineUpsellVisibility = timesLoaded => {
    const {
      openModal,
      hasSeenUpsell,
      markUpsellSeen,
      disableUpsell,
      timesToLoadBeforeUpsell,
    } = this.props;

    // Fire up the upsell modal after the user loads up X
    // new batches of photos, according to props
    if (
      hasSeenUpsell ||
      timesLoaded !== timesToLoadBeforeUpsell ||
      disableUpsell
    ) {
      return;
    }

    openModal(WEB_GALLERY_UPSELL_MODAL);
    markUpsellSeen();
  };

  render() {
    const { ...scrollerProps } = this.props;

    return (
      <PhotoGridScrollLoader
        {...scrollerProps}
        onMoreLoaded={this.determineUpsellVisibility}
      />
    );
  }
}

export default WebGalleryScrollLoaderWithUpsell;
